export const CLASS_SELECTABLE = 'o-SearchProductListItem__selectableSection'

export const TOP_DEAL_PRODUCT_IDS = [
  '17607172',
  '17607189',
  '17607203',
  '17607195',
  '17607137',
  '17607143',
  '17607166',
  '17607226',
  '08107106',
  '08107105',
  '08107109',
  '08107108',
  '08107107',
  '08105180',
  '08105181',
  '08105182',
  '08105694',
  '08105919',
  '08105993',
  '08106001',
  '08106095',
  '08106101',
  '08106104',
  '08106192',
  '08106397',
  '08106418',
  '08106419',
  '08106420',
  '08106421',
  '08106445',
  '08106650',
  '08106692',
  '08106827',
  '08107071',
  '08107167',
  '08107168',
  '08107169',
  '08107170',
  '08107171',
  '08107172',
  '08107173',
  '08107175',
  '08107228',
  '08107229',
  '08107230',
  '08107231',
  '08107232',
  '08107233',
  '08107234',
  '08107235',
  '08107236',
  '08107237',
  '08107238',
  '08107239',
  '08107240',
  '08107241',
  '08107242',
  '08107243',
  '08107244',
  '08107245',
  '08107246',
  '08107247',
  '08107248',
  '08107249',
  '08107250',
  '08107251',
  '08107252',
  '08107253',
  '08107254',
  '08107255',
  '08107256',
  '08107257',
  '08107258',
  '08107259',
  '08107260',
  '08107261',
  '08107262',
  '08107263',
  '08107264',
  '08107265',
  '08107266',
  '08107267',
  '08107268',
  '08107269',
  '08107271',
  '08107272',
  '08107273',
  '08107274',
  '08107279',
  '08107280',
  '08107439',
  '15814955',
  '15814984',
  '15893535',
  '16013200',
  '16575777',
  '16599341',
  '16599571',
  '16599588',
  '16599594',
  '16599602',
  '16599619',
  '16599677',
  '16623944',
  '16623967',
  '16665670',
  '16665693',
  '16683892',
  '16683900',
  '16683917',
  '16732403',
  '16732426',
  '16757076',
  '16757082',
  '16762634',
  '16762692',
  '16762982',
  '16762999',
  '16763007',
  '16763042',
  '16763059',
  '16764691',
  '16805562',
  '16858707',
  '16858713',
  '16879810',
  '16881379',
  '16885414',
  '17264080',
  '17268758',
  '17268764',
  '17284148',
  '17284154',
  '17368046',
  '17386127',
  '17387954',
  '17396686',
  '17396692',
  '17396700',
  '17396717',
  '17422202',
  '17447343',
  '17506152',
  '17521430',
  '17521447',
  '17521453',
  '17534467',
  '17534473',
  '17534496',
  '17537218',
  '17543561',
  '17543584',
  '17617791',
  '17620296',
  '17756736',
  '17825265',
  '17825271',
  '17840253',
  '18050694',
]
